import type { MerchantContextShopResource } from "@/features/chat/merchantContextSchemas";
import type { MerchantStoreBinding } from "@/features/settings/storeManagementSchemas";

export function findContextShopForBinding(
  resources: ReadonlyArray<MerchantContextShopResource>,
  binding: MerchantStoreBinding,
) {
  const exact = resources.filter((resource) => resource.resourceId === binding.id);
  if (exact.length) return exact.length === 1 ? exact[0] : undefined;
  const legacy = resources.filter((resource) => resource.provider === binding.provider && resource.externalId === binding.externalShopId);
  return legacy.length === 1 ? legacy[0] : undefined;
}

export function findBindingForContextShop(
  bindings: ReadonlyArray<MerchantStoreBinding>,
  selectedShop: {
    externalId: string;
    provider: string;
    resourceId: string;
  } | null,
) {
  if (!selectedShop) return undefined;
  const exact = bindings.filter((binding) => binding.id === selectedShop.resourceId);
  if (exact.length) return exact.length === 1 ? exact[0] : undefined;
  const legacy = bindings.filter((binding) => binding.provider === selectedShop.provider && binding.externalShopId === selectedShop.externalId);
  return legacy.length === 1 ? legacy[0] : undefined;
}
